function isNestedBankQuestion(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function getQuestionData(item) {
  if (!item || typeof item !== "object") return item;
  return isNestedBankQuestion(item.question) ? item.question : item;
}

export function getQuestionId(item) {
  if (!item || typeof item !== "object") return undefined;
  if (item.question_id != null && item.question_id !== "") {
    return item.question_id;
  }
  const nested = isNestedBankQuestion(item.question) ? item.question : null;
  return nested?.id ?? item.id;
}

export function normalizeCorrectionQuestion(item) {
  if (!item || typeof item !== "object") return item;
  const question = getQuestionData(item);
  const questionId = getQuestionId(item);
  if (isNestedBankQuestion(item.question)) {
    return {
      ...item,
      question_id: questionId,
      question,
    };
  }
  return {
    id: item.id,
    question_id: questionId,
    question,
  };
}

export function normalizeCorrectionQuestions(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeCorrectionQuestion).filter(Boolean);
}
